/**
 * Build/deployment identity used to tag Sentry events.
 *
 * `__APP_RELEASE__` is replaced at build time by Vite (see vite.config.ts) with
 * "<package version>+<commit sha>", so every event can be traced to one build.
 */
declare global {
  // eslint-disable-next-line no-var
  var __APP_RELEASE__: string | undefined;
}

export const APP_RELEASE: string =
  typeof __APP_RELEASE__ === "string" ? __APP_RELEASE__ : "unknown";


export type AppEnvironment = "development" | "preview" | "production";

/**
 * Which deployment a session is running on, derived from the host so preview
 * traffic never pollutes production issue counts.
 */
export function getAppEnvironment(hostname?: string): AppEnvironment {
  const host = hostname ?? (typeof window === "undefined" ? "" : window.location.hostname);

  if (!host || host === "localhost" || host === "127.0.0.1" || host.endsWith(".local")) {
    return "development";
  }

  // Lovable preview/sandbox hosts, e.g. id-preview--<id>.lovable.app or
  // project--<id>-dev.lovable.app
  if (host.startsWith("id-preview--") || host.includes("-dev.lovable.app")) {
    return "preview";
  }

  return "production";
}
